// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3JB0Q","cardContainer":"Card_cardContainer__1pL4T","header":"Card_header__IQXxP"};